import script from "./JbButtons.vue?vue&type=script&lang=js"
export * from "./JbButtons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__